module.exports = __webpack_public_path__ + "static/media/closing-img.99124821.svg";